module.exports = __webpack_public_path__ + "img/BENTLEY.8aab822.jpg";